import { memo } from 'react';

import { type InputProps as AntInputProps, Input as AntInput } from 'antd';
import cn from 'classnames';

import cls from './input-text.module.css';

interface InputTextProps extends AntInputProps {
    isBlock?: boolean;
}

export const InputText = memo((props: InputTextProps) => {
    const { isBlock, className, ...inputTextProps } = props;

    return (
        <AntInput
            {...inputTextProps}
            className={cn(className, cls.root, { [cls.block]: isBlock })}
        />
    );
});

InputText.displayName = 'InputText';
